import { render, staticRenderFns } from "./SearchIndex.vue?vue&type=template&id=dc8836e2&"
import script from "./SearchIndex.vue?vue&type=script&lang=js&"
export * from "./SearchIndex.vue?vue&type=script&lang=js&"
import style0 from "./SearchIndex.vue?vue&type=style&index=0&id=dc8836e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports